import { motion } from "framer-motion";
import {
  Award, Layers, Globe2, Eye, BookOpen, Code2, Zap, ShieldCheck, BadgeDollarSign, Star,
} from "lucide-react";

const items = [
  { title: "15+ Years of Publishing Excellence", desc: "Deep publishing know-how since 2010.", icon: Award, color: "#1F5EFF" },
  { title: "End-to-End Content Solutions", desc: "From editorial to global distribution.", icon: Layers, color: "#6D28D9" },
  { title: "Print & Digital Publishing Expertise", desc: "EPUB3, HTML5, fixed & reflowable, print-ready.", icon: BookOpen, color: "#00B8A9" },
  { title: "WCAG & PDF/UA Accessibility Specialists", desc: "JAWS-tested, audit-ready deliverables.", icon: Eye, color: "#1F5EFF" },
  { title: "Global Delivery, Local Support", desc: "India-based team serving global clients.", icon: Globe2, color: "#6D28D9" },
  { title: "XML-First Production Workflows", desc: "DTD, schemas, structured content tagging.", icon: Code2, color: "#00B8A9" },
  { title: "Enterprise-Grade Quality Assurance", desc: "Multi-tier checks, accessibility audits.", icon: ShieldCheck, color: "#1F5EFF" },
  { title: "Scalable Teams & Fast Turnaround", desc: "Automated workflows, predictable SLAs.", icon: Zap, color: "#6D28D9" },
  { title: "Competitive Pricing Without Compromise", desc: "Cost-effective, scalable engagement models.", icon: BadgeDollarSign, color: "#00B8A9" },
  { title: "Trusted by Publishers Worldwide", desc: "Publishers, universities, museums & enterprises.", icon: Star, color: "#0B1F3A" },
];

export default function WhyChooseUs() {
  return (
    <section data-testid="why-section" className="relative py-24 sm:py-28 bg-[#F0F8FF]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="overline">Why Choose Libros Consulting</div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3A] tracking-tighter leading-[1.08]">
            Publishing expertise. Enterprise execution.
          </h2>
          <p className="mt-4 text-[#475569] text-base sm:text-lg">
            For over 15 years, Libros Consulting has partnered with publishers, educational institutions, museums,
            and enterprises to deliver high-quality print and digital content solutions. Combining publishing
            expertise, accessibility leadership, advanced technology, and scalable production workflows, we help
            organizations create, manage, and distribute content with confidence.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
                className="lift-card group rounded-2xl bg-white border border-[#0B1F3A]/10 p-6"
              >
                <div
                  className="inline-flex h-12 w-12 items-center justify-center rounded-xl mb-4 transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: `${it.color}14`, color: it.color }}
                >
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display font-semibold text-[15px] text-[#0B1F3A] leading-snug">
                  {it.title}
                </h3>
                <div className="mt-1.5 text-[13px] text-[#475569] leading-relaxed">{it.desc}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
